/**
 * useChatIssueTags — Iter 156.22 (Phase A, Yash).
 * Extracted from `ChatsPage.jsx`. Owns the catalog of available issue tags
 * and the toggle handler for the currently-selected lead's tag set.
 *
 * The previous-version `[issueTags, setIssueTags]` state was orphaned —
 * tag membership lives on `selectedLead.issue_tags` and is mutated via the
 * `setSelectedLead` setter the caller already owns. Dropping it removes a
 * dead-state slot.
 */
import { useCallback, useState } from "react";
import { toast } from "sonner";
import { issueTagsApi } from "../lib/api";

export default function useChatIssueTags(selectedLead, setSelectedLead) {
  const [availableIssueTags, setAvailableIssueTags] = useState([]);

  const fetchIssueTags = useCallback(async () => {
    try {
      const res = await issueTagsApi.getAll();
      setAvailableIssueTags(res.data.tags || []);
    } catch {
      /* fall back to whatever we had; the picker just shows fewer chips */
    }
  }, []);

  const toggleIssueTag = useCallback(async (tag) => {
    if (!selectedLead) return;
    const current = selectedLead.issue_tags || [];
    const updated = current.includes(tag)
      ? current.filter((t) => t !== tag)
      : [...current, tag];
    try {
      await issueTagsApi.updateLead(selectedLead.id, updated);
      setSelectedLead((prev) => (prev ? { ...prev, issue_tags: updated } : prev));
      toast.success("Tags updated");
    } catch {
      toast.error("Failed");
    }
  }, [selectedLead, setSelectedLead]);

  return { availableIssueTags, fetchIssueTags, toggleIssueTag };
}
